import React from 'react';
export function GiftIcon(props: SVGProps<SVGSVGElement>) {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props} data-id="element-167">
      <polyline points="20 12 20 22 4 22 4 12" data-id="element-168" />
      <rect x="2" y="7" width="20" height="5" data-id="element-169" />
      <line x1="12" y1="22" x2="12" y2="7" data-id="element-170" />
      <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z" data-id="element-171" />
      <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z" data-id="element-172" />
    </svg>;
}